var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRightRounded = function SvgArrowRightRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 7.898a1.524 1.524 0 0 0-.45-1.067L9.616 3.555a.762.762 0 1 0-1.074 1.082l2.507 2.499h-7.62a.762.762 0 1 0 0 1.524h7.62L8.54 11.166a.762.762 0 0 0 1.074 1.082l3.269-3.276c.286-.284.448-.67.45-1.074Z"
  })));
};
export default SvgArrowRightRounded;